// extracted by mini-css-extract-plugin
export default {"wrapper":"SmyR3oBh5gGBYoOXpvxQ","info":"bJL2XQZ85gFrkWJzQAIZ","controls":"zZNd82e4yEhXVu6Y0xrH","ellipsis":"AGex72Rjo4n0i27TDKIy"};